import { render, staticRenderFns } from "./PonovnePosete.vue?vue&type=template&id=2c868650&scoped=true&"
import script from "./PonovnePosete.vue?vue&type=script&lang=ts&"
export * from "./PonovnePosete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c868650",
  null
  
)

export default component.exports